import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import * as pubsub from "pubsub-js"
import moment from 'moment';
import {firstValueFrom} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {StorageKeysEnum} from "../../../enums/storage-key.enum";
import {PaymentSuccessModel} from "../../../models/payments/payment-success.model";

@Component({
  selector: 'lib-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  @Input() texts: any;
  @Input() paymentSuccessModel!: PaymentSuccessModel;
  @Input() loading: boolean = false;
  modalRef!: NgbModalRef;
  today: string = ""
  isDateProgrammed: boolean = false
  @Output() downloadPdfEvent: EventEmitter<any> = new EventEmitter<any>()
  @Output() closeSuccessModalEvent: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    const browserLang = this.translate.getBrowserLang();
    const sessionLang = sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE)
    let lang = sessionLang ? sessionLang : (browserLang?.match(/es|en/) ? browserLang : "es");
    moment.locale(lang)
    this.today = lang == "es" ? moment().format("D [de] MMMM [de] YYYY") : moment().format("MMMM D, YYYY");
  }

  downloadPdf() {
    this.downloadPdfEvent.emit(this.paymentSuccessModel?.tracking)
  }

  banxicoUrlCEP() {
    const banxico = this.paymentSuccessModel.urlCEP;
    window.open(banxico, '_blank');
  }

  closeModal() {
    this.closeSuccessModalEvent.emit();
  }
}
